<template>
	<vxe-modal v-model="modal" width="1000" height="800" @show="show" @hdie="hide" :title="title" destroy-on-close
		:showFooter="true">
		<template #default>
			<vxe-toolbar>
				<template #buttons>
					<vxe-button status="primary" @click="addtask">创建任务</vxe-button>
				</template>
			</vxe-toolbar>
			<vxe-table :data="tableData" border>
				<vxe-column type="seq" width="60"></vxe-column>
				<vxe-column field="name" title="任务名称"></vxe-column>
				<vxe-column field="begin_time" title="开始时间">
					<template #default="{ row }">
						<span>{{timestampToDate(row.begin_time)}}</span>
					</template>
				</vxe-column>
				<vxe-column field="end_time" title="结束时间">
					<template #default="{ row }">
						<span>{{timestampToDate(row.end_time)}}</span>
					</template>
				</vxe-column>
				<vxe-column field="progress" title="进度"></vxe-column>
				<vxe-column field="status" title="状态">
					<template #default="{ row }">
						<span>{{row.status==0?'停止':'启动'}}</span>
					</template>
				</vxe-column>
				<vxe-column title="操作" width="180" show-overflow align="center">
					<template #default="{ row }">
						<vxe-button type="text" status="primary" @click="checkSettlementTask(row)">查看</vxe-button>
						<vxe-button type="text" status="warning" @click="updateSettlementTaststatus(row.id,0)"
							v-if="row.status==1">停止</vxe-button>
						<vxe-button type="text" status="success" @click="updateSettlementTaststatus(row.id,1)"
							v-if="row.status==0">启动</vxe-button>
						<vxe-button type="text" status="danger" @click="deleteSettlementTask(row.id)">删除</vxe-button>
					</template>
				</vxe-column>
			</vxe-table>

			<vxe-modal :before-hide-method="buforeTasFormkHide" v-model="formShow" title="新建任务" width="800" height="600"
				@show="taskshow" @hide="taskhide" destroy-on-close :showFooter="true">
				<template #default>
					<el-form ref="form" :model="form" label-width="80px" size="mini">
						<el-form-item label="任务名称">
							<forminput :readonly="Boolean(id)" v-model="form.name" />
						</el-form-item>
						<el-form-item label="时间范围">
							<datePicker :readonly="Boolean(id)" v-model="form.date" />
						</el-form-item>
					</el-form>
					<vxe-toolbar>
						<template #buttons>
							<vxe-button @click="importwhite" status="primary" v-if="!id">导入月结</vxe-button>
							<vxe-button @click="update" status="primary" v-if="id">更新</vxe-button>
							<vxe-button @click="exportSettlementData">导出</vxe-button>
						</template>
					</vxe-toolbar>
					<vxe-table ref="tasktable" :data="tasktableData" height="400" border>
						<vxe-column type="seq" width="50" align="center"></vxe-column>
						<vxe-column field="name" title="供应商名称"></vxe-column>
						<vxe-column field="code" title="供应商编码"></vxe-column>
						<vxe-column field="wlnid" title="万里牛ID"></vxe-column>
						<vxe-column field="incode" title="入库结算单"></vxe-column>
						<vxe-column field="inamount" title="入库结算金额"></vxe-column>
						<vxe-column field="outcode" title="退货结算单"></vxe-column>
						<vxe-column field="outamount" title="退货结算金额"></vxe-column>
						<vxe-column title="操作" width="100" show-overflow align="center" v-if="id==0">
							<template #default="{ row }">
								<vxe-button status="danger" type="text" icon="vxe-icon-delete"
									@click="taskDeleteSupplier(row)">删除</vxe-button>
							</template>
						</vxe-column>
					</vxe-table>
				</template>
			</vxe-modal>

		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
		</template>
	</vxe-modal>

</template>
<style scoped>

</style>
<script>
	import forminput from '@_system/components/formcomponents/common/input/index.vue'
	import datePicker from '@_system/components/formcomponents/common/datePicker/index.vue'
	export default {
		props: {
			title: {
				type: String,
				default: () => {
					return {}
				}
			},
			row: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				id: 0,
				modal: false,
				loading: false,
				tableData: [],
				formShow: false,
				tasktableData: [],
				form: {
					name: null,
					date: null
				}

			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			listSettlementTask() {
				this.$api.supplier.listSettlementTask().then((res) => {
					this.tableData = res
				})
			},
			getSettlementTask(id) {
				this.$api.supplier.getSettlementTask(id).then((res) => {
					this.form = {
						name: res.name,
						date: [res.begin_time * 1000, res.end_time * 1000]
					}
					this.tasktableData = res.supplier
					//this.getSettlementSupplier()
				})
			},
			updateSettlementTaststatus(id, status) {
				this.$api.supplier.updateSettlementTaststatus({
					id: id,
					status: status
				}).then(() => {
					this.listSettlementTask()
				})
			},
			checkSettlementTask(row) {
				this.id = row.id
				this.formShow = true
			},
			deleteSettlementTask(id) {
				this.$confirm('是否确认删除', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.supplier.deleteSettlementTask(id).then(() => {
						this.$message.success('操作成功')
						this.listSettlementTask()
					})
				}).catch(() => {

				})
			},
			addtask() {
				this.id = 0
				this.tasktableData = []
				this.form = {
					name: null,
					date: null
				}
				this.formShow = true
			},
			taskshow() {
				if (this.id != 0) {
					this.getSettlementTask(this.id)
				}
				// if (this.id == 0) {
				// 	this.getSettlementSupplier()
				// } else {
				// 	this.getSettlementTask(this.id)
				// }

			},
			importwhite(){
				this.getSettlementSupplier()
			},
			taskhide() {
				this.listSettlementTask()
			},
			exportSettlementData() {
				let fullData = this.$refs.tasktable.getTableData().fullData
				this.$refs.tasktable.exportData({
					filename: this.form.name,
					type: 'xlsx',
					data: fullData
				})
			},
			reflash(){
				this.getSettlementSupplier()
			},
			update(){
				this.getSettlementSupplier().then(()=>{
					let supplier = this.$refs.tasktable.getTableData().fullData
					this.$api.supplier.updateSettlementTast({
						id: this.id,
						supplier: supplier,
					}).then(() => {
						this.$message.success('操作成功')
					})
				})
			},
			buforeTasFormkHide(e) {
				return new Promise((reslove, reject) => {
					if (e.type == 'confirm' && !this.id) {
						let supplier = this.$refs.tasktable.getTableData().fullData
						if (!this.form.name) {
							this.$message.error('请填写任务名称')
							reject()
						} else if (!this.form.date) {
							this.$message.error('请填选择时间范围')
							reject()
						}else {
							this.$api.supplier.addSettlementTast({
								name: this.form.name,
								begin: this.form.date[0] / 1000,
								end: this.form.date[1] / 1000,
								supplier: supplier,
							}).then((res) => {
								if (res.success) {
									this.$message.success('操作成功')
									reslove()
								} else {
									this.$confirm(res.msg + ',是否删除重复数据', '错误', {
										confirmButtonText: '确定',
										cancelButtonText: '取消',
										type: 'error'
									}).then(() => {
										let intersection = supplier.filter(item => res.error.map(
											item2 =>
											item2.code).includes(item.code))
										this.$refs.tasktable.remove(intersection)
									}).catch(() => {

									})

									reject()
								}
							}, () => {
								reject()
							})
						}

						//console.log(this.form, supplier)
					} else {
						reslove()
					}
				})
				//return new Error()
			},
			getSettlementSupplier() {
				return new Promise((reslove)=>{
					this.$api.supplier.list({
						paymentmethod: 8806
					}).then((res) => {
						//console.log(res)
						let difference = res.list.filter(obj1 => !this.tasktableData.some(obj2 => obj1.wlnid === obj2
							.wlnid))
						//console.log(difference)
						this.tasktableData = this.tasktableData.concat(difference)
						reslove()
					})
				})
			},
			taskDeleteSupplier(e) {
				this.$refs.tasktable.remove(e)
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.activeName = this.device == 'pc' ? 'order' : 0
				this.$emit('hide')
			},
			show() {
				this.listSettlementTask()
			},
			modalShow() {
				this.modal = true
			},
			timestampToDate(timestamp) {
				return window.systemMethods.timestampToDate(timestamp, true)
			}
		},
		components: {
			forminput,
			datePicker
		}
	}
</script>